/**
 * The readings behind choosing who a staff invitation is for (ADR 0034).
 */
import type { PeopleRegisterRow } from "@/lib/api/people";

export type StaffInvitationPersonMode = "existing" | "new";

/**
 * Why the server would refuse a staff invitation naming this person, or null:
 * a person who already signs in (`person_already_member`) or whose invitation
 * is still open (`person_invitation_open`).
 */
export function staffInvitationRefusal(person: PeopleRegisterRow): string | null {
  if (person.archived_at) return "Restore this person to People before inviting them";
  if (person.user_id) return "Already signs in";
  if (person.invitation_pending) return "Invitation already open";
  return null;
}

/** The person's name as a given and a family name: the last word is the family name. */
export function splitPersonName(fullName: string | null): { given: string; family: string } {
  const words = (fullName ?? "").trim().split(/\s+/).filter(Boolean);
  if (words.length < 2) return { given: words[0] ?? "", family: "" };
  return { given: words.slice(0, -1).join(" "), family: words[words.length - 1] };
}
